var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondChristmas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6126 8.21546V7.71546H34.1126H31.0552C30.4229 5.67071 29.5406 3.9283 28.4718 2.6677C27.3411 1.33409 25.9637 0.5 24.4336 0.5C22.9036 0.5 21.5262 1.33409 20.3955 2.6677C19.3267 3.9283 18.4443 5.67071 17.8121 7.71546H14.7547H14.2547V8.21546V16.2626C6.13134 20.0325 0.5 28.2449 0.5 37.7837C0.5 50.8786 11.1152 61.5 24.2163 61.5C37.3172 61.5 47.9325 50.8847 47.9325 37.7837C47.9325 28.4156 42.4999 20.3193 34.6126 16.4688V8.21546ZM27.689 7.71546H21.1721C21.5548 6.4728 22.0343 5.45803 22.5679 4.73475C23.193 3.88748 23.8341 3.51194 24.4306 3.51067C25.0239 3.51194 25.665 3.88716 26.2912 4.73496C26.8254 5.45832 27.3061 6.47308 27.689 7.71546Z",
    fill: "#AAA9AD",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1553 45H18.5633V42.792C24.7793 38.088 27.2033 36 27.2033 33.696C27.2033 32.016 25.7633 31.248 24.2993 31.248C22.4273 31.248 20.9873 32.016 19.9793 33.168L18.3473 31.32C19.7633 29.616 22.0193 28.752 24.2513 28.752C27.3473 28.752 30.0593 30.504 30.0593 33.696C30.0593 36.648 27.3473 39.288 23.0513 42.528H30.1553V45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondChristmas);
export default __webpack_public_path__ + "static/media/secondChristmas.f83e2baae7b8c1e509a5e6adf4c280f2.svg";
export { ForwardRef as ReactComponent };